<template>
  <div ref="containerRef" class="global-search-dropdown">
    <InputSearch
      :is-focus="isFocus"
      :search-key="searchKey"
      @focus="onfocusInputSearch"
      @focusout="closeInputSearch"
      @close-menu="closeMenu"
      @change-search-key="onChangeSearchKey"
      @on-search="onSearchInput"
      @click="emits('onClickInputSearch')"
    />
    <MenuSearch
      :is-show="isFocus"
      :searching="searching"
      :search-key="searchKey.trim()"
      @close-menu="closeMenu"
      @update-search-key="updateCurrentValueSearchKey"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from "vue";

/** components */
import InputSearch from "@/components/common/globalSearch/inputSearch.vue";
import MenuSearch from "@/components/common/globalSearch/menuSearch/index.vue";
import { SEARCH_TYPE_ID } from "@/utils/constants";
import store from "@/store";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";

const containerRef = ref<HTMLDivElement | null>(null);
const isFocus = ref(false);
const searchKey = ref("");
const searching = ref(0);
const lastCallApiValueSearch = ref("");
let valueSearch = "";

const emits = defineEmits(["onClickInputSearch"]);

const onChangeSearchKey = (value: string) => {
  searchKey.value = value;
};

const closeMenu = () => {
  searchKey.value = "";
  isFocus.value = false;
};

const onfocusInputSearch = () => {
  valueSearch = searchKey.value;
  isFocus.value = true;
};

const onSearchInput = () => {
  searching.value += 1;
  if (searchKey.value && searchKey.value !== lastCallApiValueSearch.value) {
    postAndGetRecentSearch();
  }
};

const closeInputSearch = () => {
  setTimeout(() => {
    if (searchKey.value !== valueSearch) searching.value += 1;
  }, 200);
  if (searchKey.value && searchKey.value !== lastCallApiValueSearch.value) {
    postAndGetRecentSearch();
  }
};

const onClickOutside = (even: Event) => {
  const cond = document.getElementById("pricing-table-container");
  if (cond) {
    return;
  }
  const text = window.getSelection()?.toString() || "";
  if (text && searchKey.value.includes(text)) {
    return;
  }
  if (!containerRef.value?.contains(even.target as HTMLDivElement)) {
    closeMenu();
  }
};

const updateCurrentValueSearchKey = (value: any) => {
  searchKey.value = value;
};

const postAndGetRecentSearch = async () => {
  if (searchKey.value.trim() === "" || valueSearch === searchKey.value) return;
  lastCallApiValueSearch.value = searchKey.value;
  await store.dispatch("Assessment/postRecentSearchInput", {
    searchTypeId: SEARCH_TYPE_ID.GLOB,
    searchData: {
      text: searchKey.value,
    },
  });
  await store.dispatch("Assessment/getRecentSearches", {
    searchTypeId: SEARCH_TYPE_ID.GLOB,
  });
};

onMounted(() => {
  EventEmitter.on(EmitterEvents.CLOSE_GLOBAL_SEARCH, () => {
    closeMenu();
  });
});

watch(isFocus, () => {
  if (isFocus.value) {
    window.addEventListener("click", onClickOutside);
  } else {
    window.removeEventListener("click", onClickOutside);
  }
});
</script>

<style lang="scss" scoped>
.global-search-dropdown {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100%;
  max-width: 921px;
}
.hover-modal {
  position: absolute;
  z-index: 10000;
  top: 100px;
  left: 13px;
  width: 50%;
  border: none;
}

@media (max-width: 1318px) {
  .hover-modal {
    top: 125px;
  }
}

@media (max-width: 900px) {
  .hover-modal {
    top: 140px;
    width: 44%;
  }
}
</style>
